import React from 'react';
import PropTypes from 'prop-types';
import './index.less';
import { Menu } from 'antd';
import CompWrapper from './func';

const { SubMenu } = Menu;
const laguageIcon = require('../../../../static/image/language-icon.png');

export const NewMenu = (props) => {
  const {
    onClick, filePath, className, title,
  } = props;
  return (
    <Menu
      mode="horizontal"
      theme="light"
      onClick={onClick}
      className={`${filePath} ${className}`}
    >
      <SubMenu
        key="0"
        title={(
          <span>
            {/* <Icon type="global" /> */}
            <img src={laguageIcon} alt="" />
            {title}
          </span>
        )}
        popupClassName="menu-lang-submenu"
      >
        <Menu.Item key="en" className="item-lag-us">
          <span>English</span>
        </Menu.Item>
        <Menu.Item key="de" className="item-lag-de">
          <span>Deutsch</span>
        </Menu.Item>
      </SubMenu>
    </Menu>
  );
};

NewMenu.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

export default CompWrapper(NewMenu, 'component_menuLang');
